import {useState} from 'react';

import {MenuItemsStateContext} from '../contexts/MenuItemsStateContext';

const INITIAL_OPEN_ITEMS = {};

type MenuItemProviderProps = {
  children: React.ReactNode;
};

export function MenuItemsStateProvider({children}: MenuItemProviderProps) {
  const [openItemIds, setOpenItemIds] = useState<Record<string, boolean>>(INITIAL_OPEN_ITEMS);

  const toggle = (id: string) => {
    setOpenItemIds((prevIds) => ({
      ...prevIds,
      [id]: !prevIds[id],
    }));
  };

  const open = (id: string) => {
    setOpenItemIds((prevIds) => ({
      ...prevIds,
      [id]: true,
    }));
  };

  const close = (id: string) => {
    setOpenItemIds((prevIds) => ({
      ...prevIds,
      [id]: false,
    }));
  };

  const isOpen = (id: string) => openItemIds[id];

  const value = {
    openItemIds,
    toggle,
    open,
    close,
    isOpen,
  };

  return <MenuItemsStateContext value={value}>{children}</MenuItemsStateContext>;
}
